import React from 'react';
import { Alert, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import OperationBlockScreen from './OperationBlockScreen';
import { normalizeRole, ROLES } from '../../../shared/constants/roles';

const RECOVERY_ROLES = new Set([ROLES.SUPER_ADMIN, ROLES.DEVELOPER]);

// Auth entry routes stay reachable during a hard block so privileged roles can
// log in and pick up their bypass. Mirrors the backend, which always exempts
// /api/auth/login from the operation block.
const ALWAYS_REACHABLE_PATHS = new Set(['/login']);

const OperationBlockGate = ({ children }) => {
  const { status, block } = useSelector((state) => state.operationBlock);
  const role = useSelector((state) => state.auth.role);
  const location = useLocation();
  const normalizedRole = normalizeRole(role);
  const canBypass =
    block?.allowBypass === true &&
    Array.isArray(block?.bypassRoles) &&
    block.bypassRoles.includes(normalizedRole);
  const internalBypassActive = block?.bypassActive === true;
  const canRecoverManage =
    block?.mode === 'HARD_BLOCK' && block?.allowBypass === false && RECOVERY_ROLES.has(normalizedRole);
  const onAlwaysReachablePath = ALWAYS_REACHABLE_PATHS.has(location.pathname);

  if (
    status === 'blocked' &&
    block?.mode === 'HARD_BLOCK' &&
    !canBypass &&
    !internalBypassActive &&
    !onAlwaysReachablePath
  ) {
    return <OperationBlockScreen block={block} showManageButton={canRecoverManage} />;
  }

  return (
    <>
      {status === 'blocked' ? (
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1500 }}>
          <Alert severity={block?.mode === 'BANNER_ONLY' ? 'info' : 'warning'} square>
            {internalBypassActive
              ? 'Maintenance bypass active. You are using production as an internal tester. '
              : ''}
            {block?.title || 'Service notice'}: {canBypass ? 'Bypass active for your role. ' : ''}
            {block?.message || 'Some operations may be unavailable.'}
          </Alert>
        </Box>
      ) : null}
      {children}
    </>
  );
};

export default OperationBlockGate;
